import {FC, useState, createContext, useContext} from 'react'
import {QueryState, WithChildren, QueryStateI} from '../../../../../general/helpers'
import {SELECTED_STORAGE_KEYS} from '../../../auth/core/constant'

interface QueryRequestContextI {
  state: QueryStateI
  updateState: (updates: Partial<QueryStateI>, persistOldValues?: boolean) => void
  loading?: boolean
  toggleLoading?: () => void
}

const QueryRequestContext = createContext<QueryRequestContextI>({
  state: {page: 1, size: 10},
  updateState: () => {},
  loading: false,
  toggleLoading: () => {},
})

const LogisticsQueryRequestProvider: FC<WithChildren> = ({children}) => {
  const localFilters = sessionStorage.getItem(SELECTED_STORAGE_KEYS.LOGISTICS_FILTERS_KEY)
  const [state, setState] = useState<QueryStateI & {[key: string]: string | number}>(
    localFilters
      ? JSON.parse(localFilters)
      : {
          page: 1,
          size: 10,
        }
  )
  const [loading, setLoading] = useState<boolean>(true)

  const updateState = (updates: Partial<QueryState>, persistOldValues: boolean = true) => {
    let updatedState = {...state, ...updates} as QueryStateI & {[key: string]: string | number}
    if (!persistOldValues) {
      updatedState = {...updates} as QueryStateI & {[key: string]: string | number}
    }
    setState(updatedState)
  }

  const toggleLoading = () => setLoading((prev) => !prev)

  return (
    <QueryRequestContext.Provider value={{state, updateState, loading, toggleLoading}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useLogisticsQueryRequest = () => useContext(QueryRequestContext)
export {LogisticsQueryRequestProvider, useLogisticsQueryRequest}
